<ng-container *transloco="let t">
  @if (asset(); as asset) {
    <div class="group relative inline-flex h-full rounded" [class.cursor-pointer]="!readOnly()">
      <div class="absolute top-1 right-1 z-10 hidden group-hover:block">
        <button iButton [iDropdownMenuTrigger]="optionsMenu" variant="secondary" size="icon-sm" [disabled]="readOnly()">
          <IIcon name="moreDots" />
        </button>

        <ng-template #optionsMenu>
          <IDropdownMenu>
            <button iDropdownMenuItem (click)="selectMedia()">
              <IIcon name="edit" />
              {{ t("common.edit") }}
            </button>
            @if (allowDelete()) {
              <button iDropdownMenuItem (click)="deleteMedia()">
                <IIcon name="trash" />
                {{ t("common.delete") }}
              </button>
            }
          </IDropdownMenu>
        </ng-template>
      </div>
      <div class="max-w-[40rem]">
        @if (asset.assetId === "NOT_FOUND") {
          <IAlert type="error" [title]="t('dsp-creatives.asset_not_found')">
            <div class="flex flex-col gap-2">
              {{ t("dsp-creatives.asset_not_found_description") }}
              <div class="flex">
                <button iButton variant="secondary" (click)="selectMedia()" [disabled]="readOnly()">
                  <IIcon name="edit" />
                  {{ t("common.edit") }}
                </button>
              </div>
            </div>
          </IAlert>
        } @else {
          <div [class]="framed() ? 'h-36 w-fit rounded border' : 'contents'">
            <app-media [mediaSource]="asset.url" [mediaType]="asset.mediaType" />
          </div>
          @if (displayAssetName()) {
            <div class="mt-2 flex flex-col gap-0.5">
              <div class="text-sm text-gray-600">{{ asset.name }}</div>
              @if (durationSeconds() || (asset.width && asset.height)) {
                <div class="flex items-center gap-2 text-xs text-gray-500">
                  @if (durationSeconds(); as duration) {
                    <span class="flex items-center gap-1">
                      <IIcon name="clock" />{{ t("dsp-creatives.duration_seconds", { seconds: duration }) }}
                    </span>
                  }
                  @if (asset.width && asset.height) {
                    <span>{{ asset.width }}×{{ asset.height }}</span>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  } @else {
    <button
      iButton
      variant="secondary"
      size="sm"
      class="mt-2"
      [loading]="isLoading()"
      [disabled]="readOnly()"
      (click)="selectMedia()"
    >
      <IIcon name="image" />
      {{ addAssetLabel() }}
    </button>
  }
</ng-container>
